import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable, of } from 'rxjs';
import { MerchantsApiService } from '@app/areas/merchants/services/merchants.api.service';
import { ApplicationProfileService } from '@shared/services/application-profile.service';

@Component({
  selector: 'app-merchant-no-access',
  templateUrl: './merchant-no-access.component.html',
  styleUrls: ['./merchant-no-access.component.scss'],
  standalone: true,
  imports: [AsyncPipe, TranslateModule],
})
export class MerchantNoAccessComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly merchantsApiService = inject(MerchantsApiService);
  private readonly applicationProfileService = inject(ApplicationProfileService);

  protected representativeName = '';
  protected merchantName$: Observable<string> = of('');

  ngOnInit(): void {
    const representative = this.applicationProfileService.getApplicationProfile()?.Representative;
    this.representativeName = representative ? `${representative.NameFirst} ${representative.NameLast}`.trim() : '';

    const coalitionId = Number(this.route.snapshot.paramMap.get('coalitionId'));
    const merchantId = Number(this.route.snapshot.paramMap.get('merchantId'));

    const merchantNameFromState = history.state?.['merchantName'] as string | undefined;

    this.merchantName$ = merchantNameFromState
      ? of(merchantNameFromState)
      : this.merchantsApiService
          .getMerchants(coalitionId)
          .pipe(map((merchants) => merchants.find((m) => m.MerchantId === merchantId)?.Name ?? `#${merchantId}`));
  }
}
